<template>
  <v-text-field
    :label='label'
    :value='value'
    @input='makeUppercase'
    :rules='[rules.postalCode]'
  ></v-text-field>
</template>

<script>
import formRules from '@/mixins/formRules'
export default {
  name: 'wc-postal-code-input',
  mixins: [formRules],
  props: {
    value: {
      required: true
    },
    label: {
      required: false,
      default: 'Postal Code'
    }
  },
  data: () => ({
  
  }),
  methods: {
    makeUppercase (val) {
      if (val) {
        this.$emit('input', val.toUpperCase())
      } else {
        this.$emit('input', val)
      }
    }
  }
}
</script>
